import ViewQuiz from "./ViewQuiz";

export default ViewQuiz